import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap";
import DashboardStatBox from "./DashboardStatBox";
import {
  DashboardHorizontalBarChart,
  DashboardDonutChart,
  DashboardComparisonChart,
} from "./DashboardCharts";
import { formatHours, formatPercent } from "./dashboardStatisticsUtils";

const ManagerDashboardView = ({ data }) => {
  const { t } = useTranslation();
  const d = data;
  const absent = Math.max(0, d.teamMemberCount - d.teamMembersPresent);

  return (
    <>
      <Card className="shadow-sm border-0 mb-4 analytics-card">
        <Card.Header className="bg-light border-0 py-2 px-2 px-md-3">
          <span className="fw-semibold text-secondary small text-uppercase">
            <i className="bi bi-people me-2" />
            {t("app.analytics.teamOverview")}
          </span>
        </Card.Header>
        <Card.Body className="pt-2 pb-3 px-2 px-md-3">
          <Row className="g-2 g-md-3">
            <DashboardStatBox value={d.teamMemberCount} label={t("app.analytics.teamMemberCount")} icon="bi-people-fill" iconColor="#4A90E2" background="rgba(74, 144, 226, 0.08)" />
            <DashboardStatBox value={d.teamMembersPresent} label={t("app.analytics.teamMembersPresent")} icon="bi-person-check-fill" iconColor="#66BB6A" background="rgba(102, 187, 106, 0.08)" />
            <DashboardStatBox value={formatPercent(d.attendanceRatePercent)} label={t("app.analytics.attendanceRate")} icon="bi-graph-up" iconColor="#4ECDC4" background="rgba(78, 205, 196, 0.08)" />
            <DashboardStatBox value={d.peopleOnLeave} label={t("app.analytics.peopleOnLeave")} icon="bi-calendar-x-fill" iconColor="#E57373" background="rgba(229, 115, 115, 0.08)" />
            <DashboardStatBox value={d.peopleWorked} label={t("app.analytics.peopleWorked")} icon="bi-clock-history" iconColor="#FFA726" background="rgba(255, 167, 38, 0.08)" />
            <DashboardStatBox value={formatHours(d.totalHoursWorked)} label={t("app.analytics.totalHoursWorked")} icon="bi-hourglass-split" iconColor="#BA68C8" background="rgba(186, 104, 200, 0.08)" />
            <DashboardStatBox value={d.projectsAssigned} label={t("app.analytics.projectsAssigned")} icon="bi-kanban" iconColor="#4DD0E1" background="rgba(77, 208, 225, 0.08)" />
            <DashboardStatBox value={d.pendingLeaveRequests} label={t("app.analytics.pendingLeaveRequests")} icon="bi-hourglass-split" iconColor="#FFD54F" background="rgba(255, 213, 79, 0.08)" />
          </Row>
        </Card.Body>
      </Card>

      <Row>
        <Col xs={12} lg={6}>
          <DashboardComparisonChart
            title={t("app.analytics.teamAttendanceBreakdown")}
            icon="bi-bar-chart-steps"
            bars={[
              { key: "present", label: t("app.analytics.teamMembersPresent"), value: d.teamMembersPresent, color: "#66BB6A" },
              { key: "absent", label: t("app.analytics.notPresent"), value: absent, color: "#94a3b8" },
              { key: "leave", label: t("app.analytics.peopleOnLeave"), value: d.peopleOnLeave, color: "#E57373" },
            ]}
          />
        </Col>
        <Col xs={12} lg={6}>
          <DashboardComparisonChart
            title={t("app.analytics.teamProductivity")}
            icon="bi-clock-history"
            bars={[
              { key: "worked", label: t("app.analytics.peopleWorked"), value: d.peopleWorked, color: "#4A90E2" },
              { key: "hours", label: t("app.analytics.totalHoursWorked"), value: Math.round(d.totalHoursWorked), displayValue: formatHours(d.totalHoursWorked), color: "#FFA726" },
              { key: "pending", label: t("app.analytics.pendingLeaveRequests"), value: d.pendingLeaveRequests, color: "#FFD54F" },
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} lg={6}>
          <DashboardHorizontalBarChart
            title={t("app.analytics.employmentTypeBreakdown")}
            icon="bi-briefcase"
            items={d.employmentTypeBreakdown}
          />
        </Col>
        <Col xs={12} lg={6}>
          <DashboardDonutChart
            title={t("app.analytics.employmentTypeDistribution")}
            icon="bi-pie-chart"
            items={d.employmentTypeBreakdown}
            centerLabel={t("app.analytics.teamMembers")}
          />
        </Col>
      </Row>
    </>
  );
};

export default ManagerDashboardView;
